import { render, staticRenderFns } from "./Solicitacoes.vue?vue&type=template&id=a5e952a8&scoped=true&"
import script from "./Solicitacoes.vue?vue&type=script&lang=js&"
export * from "./Solicitacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e952a8",
  null
  
)

export default component.exports